var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-single-checkbox"},[(_vm.title)?_c('div',{staticClass:"col-12 my-0 px-0 title-container d-flex align-items-center"},[_c('p',{staticClass:"px-4 py-2 m-0"},[_vm._v(" "+_vm._s(_vm.title)+" ")])]):_vm._e(),_c('div',{staticClass:"d-flex cursor-pointer",attrs:{"id":_vm.id},on:{"click":_vm.updateValue}},[_c('div',{staticClass:"checkbox-container d-flex align-items-center",class:{
        'white-box': !_vm.checked && !_vm.error,
        'red-box': _vm.error,
        'green-box': _vm.checked,
        'has-title': _vm.title,
      }},[_c('div',{staticClass:"input fa"})]),_c('div',{staticClass:"checkbox-word-container d-flex align-items-center flex-fill",class:{
        'white-box': !_vm.checked && !_vm.error,
        'red-box': _vm.error,
        'green-box': _vm.checked,
        'has-title': _vm.title,
      }},[_c('p',{staticClass:"px-4 py-2 m-0",domProps:{"innerHTML":_vm._s(_vm.optionText)}})])]),(_vm.error)?_c('Error',{attrs:{"variant":"no-border","message":_vm.customErrorMsg}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }